import { useState } from 'react';

export default function useData<T>(initial: T) {
  const [data, setData] = useState<T>(initial);

  const update = (field: string, value: any) => {
    const parts = field.split('.');
    const key = parts[0];

    if (parts.length === 1) {
      return setData((current) => ({
        ...current,
        [key]: value,
      }));
    }

    return setData((current) => ({
      ...current,
      [key]: {
        ...current[key],
        [parts[1]]: value,
      },
    }));
  };

  const reset = () => setData({ ...initial });

  return {
    data,
    setData,
    update,
    reset,
  };
}
